import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import { CircularProgress, createStyles, FormControl, FormLabel, Grid, Tooltip, Typography, withStyles } from '@material-ui/core';
import Button from '../../../../core/Button/Button';
import getPrettyError from '../../../../utils/getPrettyError';
import Modals from '../../../../modal';
import Page from '../../../../page';
import Form from '../../../../form';
import request from '../../../../utils/request';
import FormTabs from './FormTabs';
import FieldMapping from './FieldMapping';
var CRM_ENTITIES = [{
  label: 'Leads',
  value: 'SynchronizationLeads'
}, {
  label: 'Contacts',
  value: 'SynchronizationContacts'
}, {
  label: 'Accounts',
  value: 'SynchronizationAccounts'
}];
var OPTION_LABELS = {
  salesforce: 'Salesforce',
  bpmonline: 'BPM Online',
  dynamics: 'Microsoft Dynamics'
};
var passedEOSFields = [],
    passedCRMFields = [];

var getConnectionError = function getConnectionError(errorMessage, connection) {
  if (connection.CRMType === 'salesforce') {
    if (errorMessage.indexOf('INVALID_LOGIN') !== -1) return 'Invalid username, password, security token; or user locked out.';else if (errorMessage.indexOf('UNSUPPORTED_API_VERSION') !== -1) return 'Invalid Api version specified on URL.';
  }

  return errorMessage;
};

var getMappingOptions = function getMappingOptions(crmIntegration, entityType) {
  var serverMappingOptions = crmIntegration[entityType];
  var sources = serverMappingOptions && serverMappingOptions.SourceFields ? serverMappingOptions.SourceFields.map(function (field) {
    return {
      label: field.Name,
      value: field.Name
    };
  }) : [];
  var destinations = serverMappingOptions && serverMappingOptions.DestinationFields ? serverMappingOptions.DestinationFields.map(function (field) {
    return {
      label: field.Name,
      value: field.Name
    };
  }) : [];
  return {
    sources: sources,
    destinations: destinations
  };
};

function isEmpty(obj) {
  for (var x in obj) {
    return false;
  }

  return true;
}

var getFieldMappingErrors = function getFieldMappingErrors(errors, index) {
  var errorMessages = {};

  if (!isEmpty(errors)) {
    for (var element in errors) {
      if (element.slice(element.indexOf('[') + 1, element.indexOf(']')) == index) {
        var field = element.split('.')[3]; // Source, Destination

        if (field) errorMessages[field] = errors[element];
      }
    }
  }

  return errorMessages;
};

var getErrorsForDisplay = function getErrorsForDisplay(passedArr, value, errors, index, fieldType, field) {
  var text = value.Name;

  if (passedArr.indexOf(text) !== -1) {
    errors["".concat(field, ".Mapping.Pairs[") + index + '].' + fieldType + '.Name'] = "".concat(fieldType, " mapping ").concat(text, " is already present in list");
  } else {
    passedArr.push(text);
  }
};

var validateSynchronization = function validateSynchronization(field, values) {
  var errors = {};
  if (!values) return;
  if (!values.Mapping) return;
  passedEOSFields = [];
  passedCRMFields = [];
  values.Mapping.Pairs.forEach(function (value, index) {
    var EOS = value.Source;
    var CRM = value.Destination;

    if (EOS != null && CRM != null) {
      getErrorsForDisplay(passedEOSFields, EOS, errors, index, 'Source', field);
      getErrorsForDisplay(passedCRMFields, CRM, errors, index, 'Destination', field);
    } else {
      // both must be completed
      errors["".concat(field, ".Mapping.Pairs[") + index + '].Source.Name'] = errors["".concat(field, ".Mapping.Pairs[") + index + '].Destination.Name'] = 'Cannot have empty mappings';
    }
  });
  return errors;
};

var Integration = function Integration(_ref) {
  var id = _ref.id,
      classes = _ref.classes;
  React.useEffect(function () {
    document.title = 'Settings � Email Integration � Ecrion';
  }, []);
  var connectionValue = null;
  var disableSubmit = true;
  var disabledTrial = 'Feature disabled in trial mode';
  var credentialsStr = 'Fill out your credentials to configure field mappings.';
  var trialLicense = Page.Licensing.useLicense();

  var _React$useState = React.useState({
    value: null,
    loading: true,
    error: null
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      crmIntegration = _React$useState2[0],
      setCrmIntegration = _React$useState2[1];

  React.useEffect(function () {
    request({
      url: '/backend/crm'
    }).then(function (response) {
      setCrmIntegration({
        value: response,
        loading: false,
        error: null
      });
    }).catch(function (err) {
      setCrmIntegration({
        value: null,
        loading: false,
        error: getPrettyError(err)
      });
    });
  }, []);
  var fieldMappingOptions = React.useMemo(function () {
    if (!crmIntegration.value) return {};
    var mappings = CRM_ENTITIES.reduce(function (mappings, crmEntity) {
      mappings[crmEntity.value] = getMappingOptions(crmIntegration.value, crmEntity.value);
      return mappings;
    }, {});
    return mappings;
  }, [crmIntegration.value]);

  var checkTrialOptions = function checkTrialOptions(value) {
    if (trialLicense.IsTrial) {
      if (value === 'bpmonline' || value === 'dynamics') {
        var option = '';
        if (value === 'bpmonline') option = 'BPM Online';else if (value === 'dynamics') option = 'Microsoft Dynamics';
        var message = option + ' integration is disabled in trial mode.';
        Modals.open({
          type: Modals.TYPES.CONFIRMATION,
          props: {
            windowProps: {
              header: disabledTrial,
              hasCloseIcon: true,
              style: {
                width: '50%'
              }
            },
            confirmLabel: 'Ok',
            title: disabledTrial,
            message: message,
            onConfirm: function onConfirm() {},
            hideCancel: true,
            confirmColor: 'danger'
          }
        });
        return 'salesforce';
      }
    }

    return value;
  };

  var validateForm = function validateForm(value) {
    var errors = {};
    if (!value) return;

    if (value.Connection) {
      if (value.Connection.CRMType == null) errors['Connection.CRMType'] = 'Connection type is required';
      if (value.Connection.URL == null) errors['Connection.URL'] = 'URL is required';
      if (value.Connection.Username == null) errors['Connection.Username'] = 'Username is required';
      if (value.Connection.Password == null) errors['Connection.Password'] = 'Password is required';
      if (value.Connection.CRMType === 'bpmonline' && value.Connection.ProviderType == null) errors['Connection.ProviderType'] = 'Provider type is required';
      if (value.Connection && value.Connection.CRMType === 'salesforce' && value.Connection.Token == null) errors['Connection.Token'] = 'Token is required';
    }

    if (value.SynchronizationAccounts) {
      Object.assign(errors, validateSynchronization('SynchronizationAccounts', value.SynchronizationAccounts));
    }

    if (value.SynchronizationContacts) {
      Object.assign(errors, validateSynchronization('SynchronizationContacts', value.SynchronizationContacts));
    }

    if (value.SynchronizationLeads) {
      Object.assign(errors, validateSynchronization('SynchronizationLeads', value.SynchronizationLeads));
    }

    return errors;
  };

  var testConnection = function testConnection() {
    var connection = connectionValue || crmIntegration.value.Connection;
    return request({
      url: '/backend/testconnections?connectiontype=' + connection.CRMType,
      method: 'POST',
      contentType: 'json',
      data: JSON.stringify(JSON.stringify(_objectSpread({
        Type: connection.CRMType,
        Name: connection.ConnectionName
      }, connection)))
    }).then(function () {
      Modals.open({
        type: Modals.TYPES.CONFIRMATION,
        props: {
          windowProps: {
            header: 'Test Connection Successful',
            hasCloseIcon: true,
            style: {
              width: '50%'
            }
          },
          confirmLabel: 'Ok',
          title: 'Test Connection Successful',
          message: 'Connection tested successfully.',
          onConfirm: function onConfirm() {},
          hideCancel: true
        }
      });
    }).catch(function (err) {
      Modals.open({
        type: Modals.TYPES.CONFIRMATION,
        props: {
          windowProps: {
            header: 'Error',
            hasCloseIcon: true,
            style: {
              width: '50%'
            }
          },
          confirmLabel: 'Ok',
          title: 'Error',
          message: getConnectionError(getPrettyError(err), connection),
          onConfirm: function onConfirm() {},
          hideCancel: true,
          confirmColor: 'danger'
        }
      });
    });
  };

  var removeIntegration = function removeIntegration() {
    var connection = crmIntegration.value.Connection || connectionValue;
    var message = 'Are you sure you want to stop integration with ' + OPTION_LABELS[connection.CRMType] + '?';
    new Promise(function (resolve) {
      return Modals.open({
        type: Modals.TYPES.REMOVE_INTEGRATION,
        props: {
          title: 'Remove Integration',
          message: message,
          confirmLabel: 'Ok',
          confirmingLabel: 'Ok',
          onConfirm: function onConfirm(event, resetPeople) {
            return request({
              url: '/backend/crm?resetPeople=' + resetPeople,
              method: 'DELETE',
              contentType: 'json',
              data: {}
            }).then(function (response) {
              resolve(response);
            });
          }
        }
      });
    }).then(function () {
      return history.back();
    });
  };

  var renderError = function renderError() {
    if (!crmIntegration.value) return React.createElement(React.Fragment, null);
    var value = crmIntegration.value;

    if (value.SynchronizationLeads || value.SynchronizationContacts || value.SynchronizationAccounts) {
      var error = '';
      if (value.SynchronizationLeads.Error) error += value.SynchronizationLeads.Error;
      if (value.SynchronizationContacts.Error) error += (error ? '\n' : '') + value.SynchronizationContacts.Error;
      if (value.SynchronizationAccounts.Error) error += (error ? '\n' : '') + value.SynchronizationAccounts.Error;

      if (error) {
        return React.createElement(Grid, Object.assign({
          item: true,
          xs: 6,
          sm: 6,
          md: 6,
          lg: 6
        }, formGridItemProps), React.createElement(FieldTitle, null), React.createElement(Grid, {
          container: true,
          className: classes.gridStyle
        }, React.createElement(Grid, {
          item: true
        }, React.createElement(Form.Error, null, error))));
      } else {
        return React.createElement(React.Fragment, null);
      }
    }
  };

  var getCrmTypeOptions = function getCrmTypeOptions() {
    var options = [];
    options.push({
      label: 'Salesforce',
      value: 'salesforce'
    });

    if (trialLicense.IsTrial) {
      options = options.concat([{
        label: 'Microsoft Dynamics',
        value: 'dynamics'
      }, {
        label: 'BPM Online',
        value: 'bpmonline'
      }]);
    }

    return options;
  };

  var renderFooter = function renderFooter(invalid) {
    var connection = crmIntegration.value.Connection || connectionValue;
    return React.createElement("div", {
      className: classes.footerStyle
    }, React.createElement(Button, {
      disabled: connection == null || connection != null && connection.Id == null || trialLicense.IsTrial && (connection.CRMType === 'bpmonline' || connection.CRMType === 'dynamics'),
      onClick: removeIntegration,
      style: {
        marginRight: '8px'
      },
      color: "danger"
    }, "Remove Integration"), React.createElement(Button, {
      disabled: invalid || trialLicense.IsTrial && connection != null && (connection.CRMType === 'bpmonline' || connection.CRMType === 'dynamics'),
      onClick: testConnection
    }, "Test Connection"));
  };

  var renderConnection = function renderConnection() {
    return React.createElement(Grid, Object.assign({
      item: true,
      xs: 6,
      sm: 6,
      md: 6,
      lg: 6
    }, formGridItemProps), React.createElement(Grid, {
      container: true,
      alignItems: "center"
    }, React.createElement(Grid, {
      item: true,
      xs: 4
    }, React.createElement(FormLabel, {
      htmlFor: "Connection.CRMType",
      style: {
        fontSize: '14px',
        fontWeight: 'bold'
      }
    }, "CRM")), React.createElement(Grid, {
      item: true,
      xs: 8
    }, React.createElement(Form.Fields.MultiSelect, {
      required: true,
      name: "Connection.CRMType",
      id: "crm-type",
      label: null,
      variant: "filled",
      multi: false,
      options: getCrmTypeOptions(),
      parse: function parse(value) {
        return checkTrialOptions(value);
      },
      menuPlacement: "auto"
    }))), React.createElement(Form.Spy, {
      subscription: {
        values: true
      }
    }, function (_ref2) {
      var values = _ref2.values;
      var showConnectionFields = '';
      if (!values.Connection) return null;
      if (values.Connection.CRMType === 'bpmonline') showConnectionFields = 'bpm';
      if (values.Connection.CRMType === 'salesforce') showConnectionFields = 'salesforce';
      connectionValue = values.Connection;
      return React.createElement(React.Fragment, null, React.createElement(Form.Fields.Name, {
        required: true,
        name: "Connection.URL",
        id: "url",
        label: "URL",
        autoComplete: true
      }), React.createElement(Form.Fields.Name, {
        required: true,
        name: "Connection.Username",
        id: "username",
        label: "Username",
        autoComplete: true
      }), React.createElement(Form.Fields.Password, {
        required: true,
        name: "Connection.Password",
        id: "password",
        label: "Password",
        autoComplete: true
      }), showConnectionFields === 'bpm' && React.createElement(React.Fragment, null, React.createElement(Form.Fields.MultiSelect, {
        required: true,
        name: "Connection.ProviderType",
        id: "provider-type",
        label: "Provider Type",
        variant: "filled",
        multi: false,
        options: [{
          label: 'Cookie',
          value: 'cookie'
        }, {
          label: 'Basic',
          value: 'basic'
        }]
      }), values.Connection.ProviderType === 'cookie' && React.createElement(Form.Fields.Name, {
        required: true,
        name: "Connection.AuthURL",
        id: "auth-url",
        label: "Authentication Url",
        autoComplete: true
      })), showConnectionFields === 'salesforce' && React.createElement(React.Fragment, null, React.createElement(Form.Fields.Password, {
        required: true,
        name: "Connection.Token",
        id: "token",
        label: "Security Token",
        autoComplete: true
      }), React.createElement(Grid, {
        container: true
      }, React.createElement(Grid, {
        item: true,
        xs: 4
      }), React.createElement(Grid, {
        item: true,
        xs: 8
      }, React.createElement(Typography, null, "TIP: You can get a new security token in Salesforce using Personal Settings/Reset My Security Token.")))));
    }), React.createElement(Form.Fields.Checkbox, {
      name: "EnableSynchronization",
      id: "enable-synchronization",
      label: "Enabled",
      labelPlacement: "top"
    }));
  };

  var renderFieldMappings = function renderFieldMappings(mappingOptions, field) {
    return React.createElement(Form.Spy, {
      subscription: {
        errors: true
      }
    }, function (_ref3) {
      var errors = _ref3.errors;
      return React.createElement(Form.FieldArray, {
        name: "".concat(field, ".Mapping.Pairs"),
        id: "".concat(field, "-synchronization"),
        subscription: {}
      }, function (_ref4) {
        var fields = _ref4.fields;
        return React.createElement(React.Fragment, null, fields.map(function (name, index) {
          return React.createElement(FieldMapping, {
            key: name,
            name: name,
            index: index,
            mappingOptions: mappingOptions,
            onRemove: fields.remove,
            errors: getFieldMappingErrors(errors, index)
          });
        }), React.createElement(Tooltip, {
          title: "Add mapping",
          placement: "right"
        }, React.createElement(Button, {
          onClick: function onClick() {
            return fields.push('');
          },
          style: fields.length !== 0 ? _objectSpread({}, formMapProps) : {
            marginTop: '16px'
          }
        }, fields.length !== 0 ? '+' : 'Add Mapping')));
      });
    });
  };

  var renderMappings = function renderMappings() {
    if (!crmIntegration.value) return;
    var value = crmIntegration.value;
    var connection = crmIntegration.value.Connection || connectionValue;

    if (connection && trialLicense.IsTrial && (connection.CRMType === 'bpmonline' || connection.CRMType === 'dynamics')) {
      return React.createElement(React.Fragment, null);
    } else {
      if (value.SynchronizationLeads || value.SynchronizationContacts || value.SynchronizationAccounts) {
        return React.createElement(React.Fragment, null, React.createElement(Grid, Object.assign({
          item: true,
          xs: 6,
          sm: 6,
          md: 6,
          lg: 6
        }, formGridItemProps), React.createElement(React.Fragment, null, React.createElement(Grid, {
          container: true
        }, React.createElement(Grid, {
          item: true,
          xs: 4
        }, React.createElement(FieldTitle, null)), React.createElement(Grid, {
          item: true,
          xs: 8
        })), React.createElement(FormTabs, {
          options: CRM_ENTITIES,
          crmType: crmIntegration.value.Connection.CRMType
        }, function (tab) {
          return renderFieldMappings(fieldMappingOptions[tab.value], tab.value);
        }))));
      } else {
        renderError();
      }
    }
  };

  if (trialLicense && crmIntegration.value) {
    var crmType = crmIntegration.value.Connection ? crmIntegration.value.Connection.CRMType : null;
    disableSubmit = trialLicense.IsTrial && (crmType === 'bpmonline' || crmType === 'dynamics');
  }

  var crmId = undefined;
  if (crmIntegration.value && crmIntegration.value.Connection && crmIntegration.value.Connection.Id) crmId = crmIntegration.value.Connection.Id;
  return React.createElement(React.Fragment, null, React.createElement(Typography, {
    variant: "h6",
    style: {
      paddingLeft: '16px',
      fontWeight: 'bold'
    }
  }, "Configure Integration"), crmIntegration.loading && React.createElement(Loading, null), crmIntegration.value && React.createElement(Form.Fragment, {
    key: crmId,
    subscription: {
      invalid: true
    },
    disableSubmit: disableSubmit,
    onValidate: validateForm,
    variant: "filled",
    submitAlign: "right",
    submitLabel: "Save",
    submittingLabel: "Saving...",
    dataItemProps: {
      dataType: 'integration',
      id: crmId
    },
    defaultValue: {
      Connection: {
        ConnectionName: id,
        CRMType: 'salesforce',
        URL: 'https://login.salesforce.com/services/Soap/c/32.0'
      },
      EnableSynchronization: true
    },
    onSuccess: function onSuccess(data, payload) {
      if (payload) {
        setCrmIntegration({
          value: payload,
          loading: false,
          error: null
        });
      }
    },
    renderer: function renderer(formData, renderContent, renderFooter) {
      return React.createElement(React.Fragment, null, React.createElement("div", {
        style: {
          position: 'relative',
          bottom: '32px',
          paddingRight: '16px',
          minWidth: '600px'
        }
      }, renderFooter(formData)), renderContent(formData));
    },
    renderFooterLeft: function renderFooterLeft(_ref5) {
      var invalid = _ref5.invalid;
      return renderFooter(invalid);
    },
    renderContent: function renderContent() {
      return React.createElement(Grid, {
        container: true,
        direction: "row"
      }, renderConnection(), !crmId && React.createElement(React.Fragment, null, React.createElement(Grid, {
        item: true,
        xs: 6,
        sm: 6,
        md: 6,
        lg: 6
      }, React.createElement(React.Fragment, null, React.createElement(Grid, {
        container: true
      }, React.createElement(Grid, {
        item: true,
        xs: 12
      }, React.createElement(Grid, {
        item: true,
        xs: 4
      }, React.createElement(FieldTitle, null)), React.createElement(Grid, {
        item: true,
        xs: 8
      })), React.createElement(Grid, {
        item: true,
        xs: 12
      }, React.createElement("div", {
        className: classes.credendtialDiv
      }, React.createElement("span", {
        className: classes.credentialSpan
      }, credentialsStr))))))), renderMappings());
    }
  }));
};

var formGridItemProps = {
  style: {
    paddingRight: '3rem'
  }
};
var formMapProps = {
  marginTop: '16px',
  minWidth: 'auto',
  position: 'relative'
};

var styles = function styles(theme) {
  return createStyles({
    gridStyle: {
      alignItems: 'center',
      height: theme.spacing(8)
    },
    footerStyle: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    credendtialDiv: {
      height: '200px',
      textAlign: 'center',
      backgroundColor: '#eeeeee'
    },
    credentialSpan: {
      position: 'relative',
      top: '50%'
    }
  });
};

var FieldTitle = function FieldTitle() {
  return React.createElement(FormControl, {
    margin: "normal",
    style: {
      marginTop: 8 * 3
    }
  }, React.createElement(FormLabel, {
    htmlFor: "",
    style: {
      fontSize: '14px',
      fontWeight: 'bold'
    }
  }, "Field Mappings"));
};

var Loading = function Loading() {
  return React.createElement(CircularProgress, {
    size: 60,
    variant: "indeterminate",
    disableShrink: true,
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginLeft: '-25px',
      marginTop: '-25px'
    }
  });
};

export default withStyles(styles, {
  withTheme: true,
  name: 'ECIntegration'
})(Integration);